import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import smsSubscription from './smsSubscription';
import user from './user';

export default combineReducers({
  form: formReducer,
  smsSubscription,
  user,
});



// WEBPACK FOOTER //
// ./app/javascript/apps/sms_subscriptions/reducers/index.js